<template>
	<div>
		<a-layout>
			<a-layout-sider style="background: #FFFFFF;overflow: hidden; height: 100vh;" width="200px">
				<div style="padding: 30px 20px;">
					<div v-for="(item,index) in menus" :key="index" @click="goToUrl(index)" class="second-menu-item "
						:class="{on:getSelectKey.indexOf(item.key) > -1}">
						<i class="iconfont ft14" :class="item.icon"></i>
						<span class="ft14 ml10">{{item.name}}</span>
					</div>
				</div>
			</a-layout-sider>
			<a-layout-content style="padding: 30px 20px;height: 100vh; background: #F7F8FA;">
				<div>
					<router-view></router-view>
				</div>
			</a-layout-content>
		</a-layout>

	</div>
</template>

<script>
	export default {

		data() {
			return {
				showForm: false,
				isMulti: false,
				menus: [
					{
						name: '模板配置',
						icon: 'iconhome_nav05',
						key: 'template_index',
						link: '/template'
					},
					// {
					// 	name: '等级配置',
					// 	icon: 'iconhome_nav05',
					// 	key: 'level_index',
					// 	link: '/level'
					// },
				],
			}
		},
		computed: {},
		created() {
			this.filterMenusByPermission();
			this.checkMendian();
		},
		methods: {
			filterMenusByPermission() {
				// 获取权限字符串
				const caidanStr = localStorage.getItem('beautiful-caidan');
				if(caidanStr == 'all'){
					return;
				}
				const allowedKeys = caidanStr.split(',');
				
				// 过滤菜单
				this.menus = this.menus.filter(menu => 
					allowedKeys.includes(menu.key)
				);
        	},
			checkMendian() {
				this.$http.api('admin/getShopMendianSetting').then(res => {
					this.isMulti = res.is_multi == 1 ? true : false;
				}).catch(res => {

				})
			},
			goToUrl(index) {
				this.refreshPage(this.menus[index].link);
			},
		}
	}
</script>

<style>

</style>
